<script>
export default {
  name: 'ShowIfAuthenticated',
  data() {
    return {
      isAuth: false,
    };
  },
  mounted() {
    const meta = document.head.querySelector('meta[name="is-auth"]').content;
    this.isAuth = meta && meta === 'true';
  },
  render() {
    return this.$scopedSlots.default({
      isAuth: this.isAuth,
    });
  },
};
</script>
